import React, { useState, useEffect } from "react";
import { Layout, Space } from "antd";
import { Link } from "react-router-dom";
import Headers from "../frame/headers.component";
import Footers from "../frame/footers.component";
import AuthService from "../../services/auth.service";
import { API_BASE_URL } from "../../services/apiConfig";
import { Input, Button, Image, Table } from "antd";
import { json } from "stream/consumers";
import {API_BASE_URL_ISSUER} from "../../services/apiConfig";
import Stomp from "stompjs";
import SockJS from "sockjs-client";
import "../styles/custom.css";

const Waitview: React.FC = () => {
  const [did, setDid] = useState<string | null>(null);
  const [tokendata, settokendata] = useState<string | null>(null);
  const [contentLength, setcontentLength] = useState<number>(0);
  const [selectedDeviceName, setSelectedDeviceName]= useState<string | null>("");
  const [stompClient, setStompClient] = useState<Stomp.Client | null>(null); 
  const [selecteagentSetting, setselecteagentSetting] = useState<any[]>([]);
  const [selectroom, setselectroom] = useState<any[]>([]);
  const [selectmemberidsoket, setselectmemberidsoket] = useState<any>("");
  const [waitingtabledataArray1, setwaitingtabledataArray1] = useState<any[]>([]);
  const [waitingtabledataArray2, setwaitingtabledataArray2] = useState<any[]>([]);
  const [waitingtabledataArray3, setwaitingtabledataArray3] = useState<any[]>([]);
  const [waittingdataArray1, setwaittingdataArray1] = useState<any[]>([]);
  const [waittingdataArray2, setwaittingdataArray2] = useState<any[]>([]);
  const [waittingdataArray3, setwaittingdataArray3] = useState<any[]>([]);
  const [waittingdataAllArray, setwaittingdataAllArray] = useState<any[]>([]);
  const [display, setdisplay] = useState<string | null>(null);
  const [display1, setdisplay1] = useState<string | null>(null);
  const [display2, setdisplay2] = useState<string | null>(null);
  const [display3, setdisplay3] = useState<string | null>(null);
  const [isRoomChange, setIsRoomChange] = useState(localStorage.getItem("isroomchange"));
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    console.log("selctdeviecename 확인 :"  + localStorage.getItem("selectedDeviceName"))
    setSelectedDeviceName(localStorage.getItem("selectedDeviceName"))
  }, []);
  useEffect(() => {
    console.log("진료실변경 감지 업데이트 트리거 발동");
    fetchWaitMemberviewDataAPI();  
  }, [isRoomChange]); 
  useEffect(() => {
    const handleLocalStorageChange = () => {
      setIsRoomChange(localStorage.getItem("isroomchange"));
    };
    window.addEventListener("storage", handleLocalStorageChange);

    return () => {
      window.removeEventListener("storage", handleLocalStorageChange);
    };
  }, []); 
  useEffect(() => {
    setIsRoomChange(localStorage.getItem("isroomchange"));
  }, [localStorage.getItem("isroomchange")]);
  useEffect(() => { 
    fetchagentSettingDataAPI();
  }, [selectedDeviceName]);
  useEffect(() => {
    fetchWaitMemberviewDataAPI();  
  }, [tokendata]);
  useEffect(() => {
    console.log("받아온데이터 : " + JSON.stringify(waittingdataAllArray,null,2))
  }, [waittingdataAllArray]);
  useEffect(() => {
    const selectmemberidsoket = localStorage.getItem("selectmemberidsoket"); // Get value from localStorage

    setselectmemberidsoket(selectmemberidsoket)
  
  }, []);
  const fetchagentSettingDataAPI = async () => { 
      try {
        console.log(
          `${API_BASE_URL_ISSUER}/agentsetting/list/${localStorage.getItem( "clubNumber")}`
          
        );
        const response = await fetch(
          `${API_BASE_URL_ISSUER}/agentsetting/list/${localStorage.getItem( "clubNumber")}`,
          {
            method: "GET",

            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        const agentSettingList = data.data.agentSettingList;
        const deviceNames = agentSettingList.map((agentSetting: any) => agentSetting.deviceName);
        console.log("agentsetting 총 값 :" + JSON.stringify(agentSettingList, null, 2))
        console.log("select에 넣을 데이터 : " + deviceNames) 
        const selectedValue = selectedDeviceName;
        console.log("Selected value:  ", selectedValue);
        console.log("전체agentsetting 데이터  : " + JSON.stringify(agentSettingList, null, 2));
        const filteredData = agentSettingList.filter((item:any) => item.deviceName === selectedDeviceName);
        console.log("최종agentsetting값 : " + JSON.stringify(filteredData,null,2))
        setselecteagentSetting(filteredData);
      } catch (error) {
        console.error("(ExcelUpload) Error fetching data:", error);
      }
  };

  useEffect(() => {
    const totalRooms = selectroom.length;
    const rotations = Math.ceil(totalRooms / 3);
    let currentRotation = 0;
    const displayBatchAndScheduleNext = () => {
      const startIndex = currentRotation * 3;
      const endIndex = Math.min(startIndex + 3, totalRooms);
      const roomBatch = selectroom.slice(startIndex, endIndex).join(",");

      if (roomBatch !== "") {
        setdisplay(roomBatch);
      
        const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
        const displayparam2 =roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
        const displayparam3 =roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";

        WaitMemberviewDataUpdate(displayparam1, displayparam2, displayparam3);
        setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
        setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
        setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
        currentRotation = (currentRotation + 1) % rotations;

      }else{
        setdisplay("진료실");


        WaitMemberviewDataUpdate("", "","");
        setdisplay1("진료실");
        currentRotation = (currentRotation + 1) % rotations;
      }

      console.log("10초")
    };
    displayBatchAndScheduleNext(); 
    
  const intervalId = setInterval(displayBatchAndScheduleNext, 10000);

  return () => clearInterval(intervalId);
  }, [selectroom,waittingdataAllArray]);
  useEffect(() => {
    const agentSettings = selecteagentSetting.map((item) => JSON.parse(item.agentSetting));
    agentSettings.forEach((agentSetting) => {
      const symptoms = agentSetting.증상.map((symptom:any) => Object.keys(symptom)[0]);
      const treatmentRooms = agentSetting.진료실.map((room:any) => Object.keys(room)[0]);
      setselectroom(treatmentRooms)
    });
  }, [selecteagentSetting]);
 

  const WaitMemberviewDataUpdate = async (
    displayparam1: string,
    displayparam2: string,
    displayparam3: string
  ) => {
    if (tokendata !== null) {
      try {

            let waittingdataArray1: any[] = [];
            let waittingdataArray2: any[] = [];
            let waittingdataArray3: any[] = [];


            console.log("전체 확인 :" + JSON.stringify(waittingdataAllArray,null,2))
            waittingdataAllArray.forEach((row: any, index: number) => {
              let trimmedValue;
              const questionnaireValue = row[3];
              if(questionnaireValue!==null){
                trimmedValue = questionnaireValue.split("#")[1].split(",")[0];

              }

              console.log("trimmedValue : " +trimmedValue)
              const invitationEmptyLocalNameValid = row[4];                                                                                       
              const invitationClubValid = row[5]; 
              const isnewmember =row[8];
              let membername=null;
              let memberlocalname=null;
              let membermobilenumber=null;
              let state=null;
            
              if (isnewmember === "번호접수") {
                membername = waittingdataAllArray[index][1];
                memberlocalname = waittingdataAllArray[index][6];
                membermobilenumber = waittingdataAllArray[index][7];
                state = waittingdataAllArray[index][8];
            } else {
                if (invitationClubValid === false) {
                    membername = waittingdataAllArray[index][1];
                    memberlocalname = waittingdataAllArray[index][6];
                    membermobilenumber = waittingdataAllArray[index][2];

                } else {
                        membername = waittingdataAllArray[index][8];
                        memberlocalname = waittingdataAllArray[index][6];
                        membermobilenumber = waittingdataAllArray[index][7];
                }
            }

            if(displayparam1!==""){
              if (trimmedValue === displayparam1) {
                const waitNumber = waittingdataAllArray[index][0];
                waittingdataArray1.push([waitNumber, membername, membermobilenumber]);
              }
              if (trimmedValue === displayparam2) {
                const waitNumber = waittingdataAllArray[index][0];
                waittingdataArray2.push([waitNumber, membername, membermobilenumber]);
              }
              if (trimmedValue === displayparam3) {
                const waitNumber = waittingdataAllArray[index][0];
                waittingdataArray3.push([waitNumber, membername, membermobilenumber]);
              }
            }else{
              const waitNumber = waittingdataAllArray[index][0];
              console.log(waitNumber);
              console.log(membername);
              console.log(membermobilenumber);
              console.log(state);

              waittingdataArray1.push([waitNumber, membername, membermobilenumber, state]);
              setdisplay1("진료실")
            }

              console.log("룸개수   : "+ selectroom)


            });
            setwaittingdataArray1([...waittingdataArray1]);
            setwaittingdataArray2([...waittingdataArray2]);
            setwaittingdataArray3([...waittingdataArray3]);
    
      } catch (error) {
        // console.error("(ExcelUpload) Error fetching data:", error);
      }
    }
  };
  const fetchWaitMemberviewDataAPI = async ( ) => {
    if (tokendata !== null) {
      try {
        const currentDate = new Date();
        const localOffset = currentDate.getTimezoneOffset() * 60000; // offset in milliseconds
        const correctedDate = new Date(currentDate.getTime() - localOffset);

        const formattedDate = correctedDate.toISOString().split("T")[0];

        console.log("선택한 진료과 : " + selectedDeviceName);
        console.log(`${API_BASE_URL}/club/agent/reception/waiting/list/department/${localStorage.getItem( "clubNumber")}/${formattedDate}/${selectedDeviceName}?page=0&size=10&sort=agentClubWaitingSeq,desc`)
        fetch(
          `${API_BASE_URL}/club/agent/reception/waiting/list/department/${localStorage.getItem( "clubNumber")}/${formattedDate}/${selectedDeviceName}?page=0&size=10000&sort=agentClubWaitingSeq,desc`,
          {
            headers: {
              Authorization: `Bearer ${tokendata}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            const sortedData = {
              ...data,
              data: {
                ...data.data,
                content: data.data.content
                  .sort(
                    (a: any, b: any) =>
                      a.agentClubWaitingSeq - b.agentClubWaitingSeq
                  )
                  .map((item: any, index: number) => ({
                    ...item
                  })),
              },
            };
            if (data.data.content.length !== 0) {
              console.log("데이터 개수 : " + data.data.content.length)
              setcontentLength(data.data.content.length);
            }

            console.log("test : " + JSON.stringify(sortedData.data.content,null,2))
            console.log("test2 : " + sortedData.data.content.length)
            
            const sortedExcelRows = sortedData.data.content
              .filter((item: any) => item.flag === true)
              .map((item: any) => {
                const { memberName, mobileNumber, flag } = item;

                return {
                  waitnumber: item.displayWaitingNum,
                  memberName,
                  mobileNumber,
                  flag,
                  agentClubSeq: item.agentClub.agentClubSeq,
                  // memberDidSeq: item.memberDid.memberDidSeq,
                  questionnaire: item.questionnaire,
                  invitationEmptyLocalNameValid: item.invitationEmptyLocalNameValid,
                  invitationClubValid: item.invitationClubValid,
                  invitationLocalName: item.invitationLocalName,
                  invitationMobileNumber: item.invitationMobileNumber,
                  invitationName: item.invitationName
                };
              })
              .sort(
                (a: any, b: any) =>
                  a.agentClubWaitingSeq - b.agentClubWaitingSeq
              );
              console.log("test3 : " + sortedExcelRows.length)

              console.log("test4 : " + JSON.stringify(sortedData,null,2))
            const excelRows = sortedExcelRows.map((item: any) => [
              item.waitnumber,
              item.memberName,
              item.mobileNumber,
              item.questionnaire,
              item.invitationEmptyLocalNameValid,
              item.invitationClubValid,
              item.invitationLocalName,
              item.invitationMobileNumber,
              item.invitationName,
            ]);
            console.log("waitdataAll : " + JSON.stringify(excelRows,null,2))
            setwaittingdataAllArray(excelRows)

          });
      } catch (error) {
        // console.error("(ExcelUpload) Error fetching data:", error);
      }
    }
  };
useEffect(() => {
  if (tokendata !== null) {

    try{
      if (!stompClient || !stompClient.connected) {
        console.log("소켓 실행");
  
        const socket = new SockJS(API_BASE_URL + "/ws");
        console.log("소켓 아이디 : " + selectmemberidsoket);
        var stomp = Stomp.over(socket);
    
        const headers = { 'sender': selectmemberidsoket, 'type': 'waiting' };
        if (stomp && stomp.connected) { // stompClient가 존재하고 연결되어 있는지 확인
            console.log("WebSocket 연결이 해제되었습니다.");
            stomp.disconnect(() => {
                console.log("WebSocket 연결이 성공적으로 종료되었습니다.");
            });
        }
        stomp.connect(
            headers,
            function (frame) {
                console.log("연결 성공");
  
                stomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
                    try {
                        console.log("message: ", message);
                        if (tokendata !== null) {
                            console.log("리프레시 실행");
                            fetchagentSettingDataAPI();
                            fetchWaitMemberviewDataAPI();  
                        }
                    } catch (error) {
                        console.error("Error parsing message:", error);
                    }
                });
  
                setStompClient(stomp); 
            },
            (error) => {
                console.error("Error during WebSocket connection:", error);
            }
        );
        // 소켓 연결이 끊어졌을 때 재연결을 시도합니다.
        stomp.ws.onclose = () => {
            console.log("WebSocket 연결이 끊어졌습니다.");
                setStompClient(null)
        };
  
        // WebSocket 연결 에러 처리
        stomp.ws.onerror = () => {
            console.log("WebSocket 연결 에러.");
            setStompClient(null)
            const intervalId = setInterval(() => {
                console.log("재연결을 시도합니다.");
                const newSocket = new SockJS(API_BASE_URL + "/ws");
                const newStomp = Stomp.over(newSocket);
                newStomp.connect(
                    headers,
                    function (frame) {
                        console.log("연결 성공");
                        clearInterval(intervalId); 
                        newStomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
                            try {
                                console.log("message: ", message);
                                if (tokendata !== null) {
                                    console.log("리프레시 실행");
                                    fetchagentSettingDataAPI();
                                    fetchWaitMemberviewDataAPI();  
                                }
                            } catch (error) {
                                console.error("Error parsing message:", error);
                            }
                        });
        
                        setStompClient(stomp); 
                    },
                    (error) => {
                        console.error("Error during WebSocket connection:", error);
                    }
                );
  
                newStomp.ws.onclose = () => {
                    console.log("WebSocket 연결이 끊어졌습니다.");
                        setStompClient(null)
                };
                newStomp.ws.onerror = () => {
                    console.log("WebSocket 연결이 끊어졌습니다.");
                        setStompClient(null)
                };
  
  
            }, 1000); // 5초마다 실행되도록 설정
        
            // 컴포넌트가 언마운트될 때 setInterval 해제
            return () => clearInterval(intervalId);
        };
    }
    }catch(error){
      alert("소켓에러 ");
    }
  return () => {
      // 컴포넌트 언마운트 시 소켓 연결 해제
      if (stompClient) {
          stompClient.disconnect(() => {
              console.log("WebSocket 연결이 해제되었습니다.");
          });
      }
  };
};
}, [tokendata]);
  useEffect(() => {
    console.log("업데이트! : " + waittingdataArray1);
    const transformedData = waittingdataArray1.map(
      ([waitnumber, membername, mobilnumber]) => ({
        waitnumber,
        membername,
      })
    );
    transformedData.forEach(
      (item: { waitnumber: any; membername: any; number?: number }, index) => {
        item.number = index + 1;
        if (item.membername.length >= 2) {
          const lastChar = item.membername.slice(-1);
          item.membername =
            lastChar === "님"
              ? item.membername
              : item.membername.substring(0, 1) +
                " ● " +
                item.membername.substring(2);
        }
      }
    );

    setwaitingtabledataArray1(transformedData);
  }, [waittingdataArray1, display1]);

  useEffect(() => {
    const transformedData = waittingdataArray2.map(
      ([waitnumber, membername, mobilnumber]) => ({
        waitnumber,
        membername,
      })
    );
    transformedData.forEach(
      (item: { waitnumber: any; membername: any; number?: number }, index) => {
        item.number = index + 1;
        if (item.membername.length >= 2) {
          const lastChar = item.membername.slice(-1);
          item.membername =
            lastChar === "님"
              ? item.membername
              : item.membername.substring(0, 1) +
                " ● " +
                item.membername.substring(2);
        }
      }
    );

    setwaitingtabledataArray2(transformedData);
  }, [waittingdataArray2, display2]);

  useEffect(() => {
    const transformedData = waittingdataArray3.map(
      ([waitnumber, membername, mobilnumber]) => ({
        waitnumber,
        membername,
      })
    );
    transformedData.forEach(
      (item: { waitnumber: any; membername: any; number?: number }, index) => {
        item.number = index + 1;
        if (item.membername.length >= 2) {
          const lastChar = item.membername.slice(-1);
          item.membername =
            lastChar === "님"
              ? item.membername
              : item.membername.substring(0, 1) +
                " ● " +
                item.membername.substring(2);
        }
      }
    );

    setwaitingtabledataArray3(transformedData);
  }, [waittingdataArray3, display3]);

  useEffect(() => {
    const rawToken = AuthService.getRawToken(); // Get the undecoded token
    settokendata(rawToken);
  }, [tokendata]);

  const viewcolumns = [

    {
      title: "대기번호",
      dataIndex: "waitnumber",
      key: "waitnumber",
      width: "40%",
      render: (text: any) => (
        <span
          style={{ fontSize: width <= 1280 ? "10px" : "16px", color: "white" }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "회원명",
      dataIndex: "membername",
      key: "membername",
      width: "40%",
      render: (text: any) => (
        <span
          style={{ fontSize: width <= 1280 ? "10px" : "16px", color: "white" }}
        >
          {text}
        </span>
      ),
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: "blue",
      }}
    >
      <div style={{ height: "100px", backgroundColor: "#123758" }}>
        <div
          style={{
            backgroundColor: "#123758",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            textAlign: "left",
            color: "white",
            width: "100%",
          }}
        >
          <div
            style={{
              // width: "1000px",
              fontSize: width <= 1280 ? "40px" : "50px",
              height: "100px",
              display: "flex",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            진료대기 알림 시스템 
          </div>
          <div style={{fontSize: width <= 1280 ? "20px" : "30px",marginLeft:"30px"}}>
            진료과 : {selectedDeviceName}
          </div>
          
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100%",
          backgroundColor: "blue",
        }}
      >
        <div
          style={{
            flex: 1,
            borderStyle: "solid",
            border: "1px solid",
            backgroundColor: "blue",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              backgroundColor: "blue",
            }}
          >
            <div
              style={{
                flex: "10%",
                fontSize: width <= 1280 ? "40px" : "60px",
                textAlign: "center",
                margin: "10px",
                backgroundColor: "blue",
                color: "white",
                
              }}
            >
              {display1}
            </div>
            <div style={{ flex: "90%", backgroundColor: "blue" }}>
              <div
                style={{
                  width: "100%",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    padding: "20px",
                    fontSize: "20px",
                    backgroundColor: "blue",
                  }}
                ></div>
                {waitingtabledataArray1.length > 0 && (
                  <Table
                    className="my-custom-table"
                    dataSource={waitingtabledataArray1}
                    columns={viewcolumns.map((col) => ({
                      ...col,
                      ellipsis: true,
                      align: "center",
                      render: (text) => (
                        <span
                          style={{
                            fontSize: width <= 1280 ? "20px" : "40px",
                            color: "white",
                          }}
                        >
                          {text}
                        </span>
                      ),
                    }))}
                    pagination={false}
                    bordered={false}
                    showHeader={false}
                    style={{ width: "100%" }}
                    onRow={(record) => ({})}
                    rowKey={(record) => record.key}
                    rowClassName={undefined}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ flex: 1, borderStyle: "solid", border: "1px solid" }}>
          <div
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <div
              style={{
                flex: "10%",
                fontSize: width <= 1280 ? "40px" : "60px",
                textAlign: "center",
                margin: "10px",
                backgroundColor: "blue",
                color: "white",
              }}
            >
              {display2}
            </div>
            <div style={{ flex: "90%" }}>
              <div
                style={{
                  width: "100%",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    padding: "20px",
                    fontSize: "20px",
                  }}
                ></div>
                {waitingtabledataArray2.length > 0 && (
                  <Table
                    className="my-custom-table"
                    dataSource={waitingtabledataArray2}
                    columns={viewcolumns.map((col) => ({
                      ...col,
                      ellipsis: true,
                      align: "center",
                      render: (text) => (
                        <span
                          style={{
                            fontSize: width <= 1280 ? "20px" : "40px",
                            color: "white",
                          }}
                        >
                          {text}
                        </span>
                      ),
                    }))}
                    pagination={false}
                    bordered={false}
                    showHeader={false}
                    style={{ border: "none", width: "100%", color: "white" }}
                    onRow={(record) => ({})}
                    rowKey={(record) => record.key}
                    rowClassName={undefined}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ flex: 1, borderStyle: "solid", border: "1px solid" }}>
          <div
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <div
              style={{
                flex: "10%",
                fontSize: width <= 1280 ? "40px" : "60px",
                textAlign: "center",
                margin: "10px",
                color: "white",
              }}
            >
              {display3}
            </div>
            <div style={{ flex: "90%" }}>
              <div
                style={{
                  width: "100%",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    padding: "20px",
                    fontSize: "20px",
                  }}
                ></div>
                {waitingtabledataArray3.length > 0 && (
                  <Table
                    className="my-custom-table"
                    dataSource={waitingtabledataArray3}
                    columns={viewcolumns.map((col) => ({
                      ...col,
                      ellipsis: true,
                      align: "center",
                      render: (text) => (
                        <span
                          style={{
                            fontSize: width <= 1280 ? "20px" : "40px",
                            color: "white",
                          }}
                        >
                          {text}
                        </span>
                      ),
                    }))}
                    pagination={false}
                    bordered={false}
                    showHeader={false}
                    style={{ border: "none", width: "100%", color: "white" }}
                    onRow={(record) => ({})}
                    rowKey={(record) => record.key}
                    rowClassName={undefined}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Waitview;

